<template>
    <div class="list-item-group" ref="c" :style="gridStyle">
        <div class="list-item" v-for="item in displayItems" :key="item.id" @click="$emit('click', {item, $event})" :class="{'z-clickable': clickable}">
            <div class="list-item-icon mr-2">
                <slot name="icon" :item="item" v-if="$scopedSlots.icon" />
            </div>
            <div class="list-item-content">
                <slot name="content" :item="item" v-if="$scopedSlots.content" />
                <div v-else>{{ item.name }}</div>
            </div>
        </div>
        <div v-if="$scopedSlots['no-items'] && displayItems.length == 0" class="list-item">
            <slot name="no-items" v-if="$scopedSlots['no-items']" />
        </div>
        <div v-if="$scopedSlots.append" class="list-item">
            <slot name="append" v-if="$scopedSlots.append" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-multi-column-list',

    props: {
        items: {
            type: Array,
            required: true,
        },
        minColumnWidth: {
            type: Number,
            default: 250
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        width: 0,
        resizeObserver: null
    }),

    computed: {
        columnCount() {
            let columnCount = Math.floor(this.width / this.minColumnWidth);
            columnCount = Math.max(columnCount, 1);
            return columnCount;
        },

        displayItems() {
            if (this.columnCount > 1) {
                return this.columnSortedItems();
            }
            return this.items;
        },
        gridStyle() {
            return {
                gridTemplateColumns: `repeat(auto-fit, minmax(${this.minColumnWidth}px, 1fr))`
            }
        }
    },

    methods: {
        columnSortedItems() {
            let sortedItems = [];
            let columnCount = this.columnCount;
            let rowCount = Math.ceil(this.items.length / columnCount);

            for (let i = 0; i < rowCount; i++) {
                for (let j = 0; j < columnCount; j++) {
                    let item = this.items[i + j * rowCount];
                    if (item) {
                        sortedItems.push(item);
                    }
                }
            }

            return sortedItems;
        }
    },

    mounted() {
        this.resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                this.width = entry.contentRect.width;
            }
        });

        if (this.$refs.c) {
            this.resizeObserver.observe(this.$refs.c);
        }
    },
    beforeDestroy() {
        if (this.resizeObserver && this.$refs.c) {
            this.resizeObserver.unobserve(this.$refs.c);
        }
    }
}
</script>

<style scoped>
.list-item-group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 0.3rem;
}

.list-item {
    display: flex;
    align-items: center;
}
</style>
